import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import logo_educacion from '../../../assets/images/logo_educacion.png';
import videoExperienciasVivenciales2025 from '../../../assets/media/MEN_UNAL_C4P2_S_L_b.mp4';
import pdfExp1 from '../../../assets/documents/2025/2025.09.30_FOTOS_C1P1_EXPER_VIVENCIAL_1.pdf';
import pdfExp2 from '../../../assets/documents/2025/2025.10.14_FOTOS_C1P1_EXPER_VIVENCIAL_2.pdf';
import pdfExp3 from '../../../assets/documents/2025/2025.10.22_FOTOS_C1P1_EXPER_VIVENCIAL_3.pdf';
import pdfExp4 from '../../../assets/documents/2025/2025.10.24_FOTOS_C1P1_EXPER_VIVENCIAL_4.pdf';
import pdfExp5 from '../../../assets/documents/2025/2025.10.24_FOTOS_C1P1_EXPER_VIVENCIAL_5.pdf';
import pdfExp6 from '../../../assets/documents/2025/2025.11.05_FOTOS_C1P1_EXPER_VIVENCIAL_6.pdf';
import pdfExp7 from '../../../assets/documents/2025/2025.11.19_FOTOS_C1P1_EXPER_VIVENCIAL_7.pdf';
import pdfExp8 from '../../../assets/documents/2025/2025.11.26_FOTOS_C1P1_EXPER_VIVENCIAL_8.pdf';
import './EstrategiasComunicacion2025.scss';

const EstrategiasComunicacion2025 = () => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [open, setOpen] = useState(false);

  const handleImageClick = (imagePath: string) => {
    setSelectedImage(imagePath);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImage(null);
  };

  // Section 1: El Buzón de la reflexión
  const section1Pdfs = [
    {
      title: 'Afiche Buzón',
      path: '/Assets/documents/N1_MEN_UNAL_C1_AFICHE BUZON.pdf',
    },
    {
      title: 'Afiches Barreras',
      path: '/Assets/documents/N1_MEN_UNAL_C1_AFICHES_BARRERAS.pdf',
    },
  ];

  // Section 2: Sígale el hilo a la inclusión
  const section2Pdf = {
    title: 'Línea de Tiempo',
    path: '/Assets/documents/N2_MEN_UNAL_C1_LINEA_DE_TIEMPO.pdf',
  };

  // Section 3: Conversando inclusivaMENte con...
  const section3Audios = [
    {
      title: 'Condición de Enfermedad',
      src: '/Assets/media/Copia de PODCAST_CONDIC_ENFERMEDAD.mp3',
    },
    {
      title: 'Discapacidad',
      src: '/Assets/media/Copia de PODCAST_DISCAPACIDAD.mp3',
    },
    {
      title: 'Trastorno de Aprendizaje',
      src: '/Assets/media/Copia de PODCAST_TRASTORNO_APRENDIZAJE.mp3',
    },
  ];

  // Section 4: La educación inclusiva en modo tendencia
  const section4Images = [
    // Folder 01
    '/Assets/images/01/MEN_C1_ACT 4_PIEZA 1-01.jpg',
    '/Assets/images/01/MEN_C1_ACT 4_PIEZA 1-02.jpg',
    '/Assets/images/01/MEN_C1_ACT 4_PIEZA 1-03.jpg',
    '/Assets/images/01/MEN_C1_ACT 4_PIEZA 1-04.jpg',
    '/Assets/images/01/MEN_C1_ACT 4_PIEZA 1-05.jpg',
    '/Assets/images/01/MEN_C1_ACT 4_PIEZA 1-06.jpg',
    '/Assets/images/01/MEN_C1_ACT 4_PIEZA 1-07.jpg',
    '/Assets/images/01/MEN_C1_ACT 4_PIEZA 1-08.jpg',
    // Folders 02-06
    '/Assets/images/02/MEN_C1_ACT-4_PIEZA-2.jpg',
    '/Assets/images/03/MEN_C1_ACT-4_PIEZA-3.jpg',
    '/Assets/images/04/MEN_C1_ACT-4_PIEZA-4.jpg',
    '/Assets/images/05/MEN_C1_ACT-4_PIEZA-5.jpg',
    '/Assets/images/06/MEN_C1_ACT-4_PIEZA-6.jpg',
  ];

  // Section 5: Yo comunico: Respeto por la diversidad
  const section5Videos = [
    {
      title: 'Reel 1',
      src: '/Assets/media/MEN_C1_REEL 1.mp4',
    },
    {
      title: 'Reel 2',
      src: '/Assets/media/MEN_C1_REEL 2.mp4',
    },
  ];

  // Section 6: Y tú ¿Qué conoces sobre la educación inclusiva?
  const section6Pdfs = [
    {
      title: 'Poster 1',
      path: '/Assets/documents/MEN_C1_AC6_POSTER 1.pdf',
    },
    {
      title: 'Poster 2',
      path: '/Assets/documents/MEN_C1_AC6_POSTER 2.pdf',
    },
    {
      title: 'Poster 3',
      path: '/Assets/documents/MEN_C1_AC6_POSTER 3.pdf',
    },
  ];

  // Section 7: Experiencias vivenciales 2025 (comunicación interna del MEN)
  const experienciasVivenciales2025 = [
    { num: 1, fecha: '30/9/25', nombre: 'Los destacados de la diversidad', objetivo: 'Movilizar entre los funcionarios del MEN las apuestas institucionales y los avances alrededor de la inclusión y equidad en la educación.', pdf: pdfExp1 },
    { num: 2, fecha: '14/10/25', nombre: '¿Quién quiere ser inclusivo?', objetivo: 'Promover reflexiones culturales alrededor de la diversidad, así como conocimientos específicos (técnicos, administrativos y pedagógicos) sobre la inclusión y equidad en la educación.', pdf: pdfExp2 },
    { num: 3, fecha: '22/10/25', nombre: 'Jugando inclusivaMENte', objetivo: 'Concientizar a los funcionarios del MEN sobre las poblaciones priorizadas del convenio y sobre acciones inclusivas alrededor de la educación inclusiva.', pdf: pdfExp3 },
    { num: 4, fecha: '24/10/25', nombre: 'Me identifico', objetivo: 'Favorecer la reflexión sobre la inclusión desde una experiencia personal, cercana y divertida, que invite a reconocer tanto nuestras diferencias como nuestros puntos en común en los funcionarios del MEN.', pdf: pdfExp4 },
    { num: 5, fecha: '29/10/25', nombre: 'Menú para la inclusión', objetivo: 'Generar conciencia sobre las barreras visibles e invisibles que enfrentan distintas personas en contextos educativos, reflexionando sobre la equidad como acceso real y justo a oportunidades.', pdf: pdfExp5 },
    { num: 6, fecha: '5/11/25', nombre: 'El Kahoot inclusivo del MEN', objetivo: 'Socializar información correspondiente a cada grupo poblacional priorizado (discapacidad, talentos o capacidad excepcionales, estudiantes en condición de enfermedad, trastornos de aprendizaje y del comportamiento).', pdf: pdfExp6 },
    { num: 7, fecha: '19/11/25', nombre: 'El TangraMEN de la inclusión', objetivo: 'Sensibilizar sobre la inclusión y equidad en la educación desde el trabajo articulado en equipo en los funcionarios del MEN.', pdf: pdfExp7 },
    { num: 8, fecha: '26/11/25', nombre: 'La vacuna contra la discriminación', objetivo: 'Reflexionar sobre las diferentes formas de exclusión y marginación alrededor de las poblaciones históricamente vulneradas para generar mecanismos de transformación cultural desde las acciones diarias.', pdf: pdfExp8 },
  ];

  return (
    <>
      {/* Banner section */}
      <Grid container className='Estrategias-banner-container'>
        <Grid item xs={12} lg={5} className='logos-left'>
          <img className="logo-1" alt="Logo Ministerio de educación" src={logo_educacion} />
        </Grid>
        <Grid item xs={12} lg={7} className='content-right'>
          <h1 className='title'><b>Conoce las Estrategias de comunicación del 2025.</b></h1>
        </Grid>
      </Grid>

      {/* Section 1: El Buzón de la reflexión */}
      <Grid container className='Estrategias-section backContraste'>
        <Grid item xs={12} className='text-container'>
          <Grid xs={11} lg={10}>
            <Typography className='section-title'>
              El Buzón de la reflexión
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12} className='text-container'>
          <Grid item xs={11} lg={10}>
            <Typography className='text-info'>
              Reflexionar sobre las barreras actitudinales, físicas y comunicativas existentes para la participación efectiva en general y específicamente en los entornos escolares.
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2} className='resources-container'>
          {section1Pdfs.map((pdf, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Button
                variant="contained"
                className="action-button purple-button"
                href={pdf.path}
                target="_blank"
                rel="noopener noreferrer"
                fullWidth
              >
                {pdf.title}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Grid>

      {/* Section 2: Sígale el hilo a la inclusión */}
      <Grid container className='Estrategias-section backContraste'>
        <Grid item xs={12} className='text-container'>
          <Grid xs={11} lg={10}>
            <Typography className='section-title'>
              Sígale el hilo a la inclusión
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12} className='text-container'>
          <Grid item xs={11} lg={10}>
            <Typography className='text-info'>
              Socializar la jurisprudencia y normativa en relación con la inclusión y la equidad en la educación en el marco nacional e internacional.
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2} className='resources-container'>
          <Grid item xs={12} sm={6} md={4}>
            <Button
              variant="contained"
              className="action-button purple-button"
              href={section2Pdf.path}
              target="_blank"
              rel="noopener noreferrer"
              fullWidth
            >
              {section2Pdf.title}
            </Button>
          </Grid>
        </Grid>
      </Grid>

      {/* Section 3: Conversando inclusivaMENte con... */}
      <Grid container className='Estrategias-section backContraste'>
        <Grid item xs={12} className='text-container'>
          <Grid xs={11} lg={10}>
            <Typography className='section-title'>
              Conversando inclusivaMENte con...
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12} className='text-container'>
          <Grid item xs={11} lg={10}>
            <Typography className='text-info'>
              Socializar avances y experiencias reales en términos del proceso de la educación inclusiva en Colombia y su impacto a nivel de políticas, prácticas y culturas.
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={3} className='audio-container'>
          {section3Audios.map((audio, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Box className="audio-player-container">
                <Typography className="audio-title">{audio.title}</Typography>
                <audio controls className="audio-player">
                  <source src={audio.src} type="audio/mpeg" />
                  Tu navegador no soporta el elemento de audio.
                </audio>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Grid>

      {/* Section 4: La educación inclusiva en modo tendencia */}
      <Grid container className='Estrategias-section backContraste'>
        <Grid item xs={12} className='text-container'>
          <Grid xs={11} lg={10}>
            <Typography className='section-title'>
              La educación inclusiva en modo tendencia
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12} className='text-container'>
          <Grid item xs={11} lg={10}>
            <Typography className='text-info'>
              Promover la diversidad y el respeto por las diferencias humanas entre los funcionarios del MEN y en los territorios.
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2} className='image-gallery-container'>
          {section4Images.map((imagePath, index) => (
            <Grid item xs={6} sm={4} md={3} lg={2} key={index}>
              <Box
                className="image-card"
                onClick={() => handleImageClick(imagePath)}
              >
                <img
                  src={imagePath}
                  alt={`Pieza gráfica ${index + 1}`}
                  loading="lazy"
                  className="gallery-image"
                />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Grid>

      {/* Section 5: Yo comunico: Respeto por la diversidad */}
      <Grid container className='Estrategias-section backContraste'>
        <Grid item xs={12} className='text-container'>
          <Grid xs={11} lg={10}>
            <Typography className='section-title'>
              Yo comunico: Respeto por la diversidad
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12} className='text-container'>
          <Grid item xs={11} lg={10}>
            <Typography className='text-info'>
              Difundir el concepto de inclusión y equidad en la educación con diferentes actores estratégicos del sector educativo.
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={3} className='video-container'>
          {section5Videos.map((video, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Box className="video-player-container">
                <Typography className="video-title">{video.title}</Typography>
                <video controls className="video-player">
                  <source src={video.src} type="video/mp4" />
                  Tu navegador no soporta el elemento de video.
                </video>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Grid>

      {/* Section 6: Y tú ¿Qué conoces sobre la educación inclusiva? */}
      <Grid container className='Estrategias-section backContraste'>
        <Grid item xs={12} className='text-container'>
          <Grid xs={11} lg={10}>
            <Typography className='section-title'>
              Y tú ¿Qué conoces sobre la educación inclusiva?
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12} className='text-container'>
          <Grid item xs={11} lg={10}>
            <Typography className='text-info'>
              Movilizar reflexiones alrededor de la eliminación de barreras existentes en el sistema educativo.
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={2} className='resources-container'>
          {section6Pdfs.map((pdf, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Button
                variant="contained"
                className="action-button purple-button"
                href={pdf.path}
                target="_blank"
                rel="noopener noreferrer"
                fullWidth
              >
                {pdf.title}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Grid>

      {/* Section 7: Experiencias vivenciales 2025 */}
      <Grid container className='Estrategias-section Estrategias-experiencias-vivenciales backContraste'>
        <Grid item xs={12} className='text-container'>
          <Grid xs={11} lg={10}>
            <Typography className='section-title'>
              Experiencias vivenciales 2025
            </Typography>
          </Grid>
        </Grid>
        <Grid item xs={12} className='text-container'>
          <Grid item xs={11} lg={10}>
            <Typography className='text-info'>
              Espacios de comunicación interna del MEN realizados durante 2025, diferentes a los encuentros de reflexión y diálogo del 2024. Ocho experiencias para movilizar, sensibilizar y generar conciencia sobre la inclusión y equidad en la educación entre los funcionarios del Ministerio.
            </Typography>
          </Grid>
        </Grid>

        {/* Video resumen */}
        <Grid container spacing={3} className='video-container' justifyContent='center'>
          <Grid item xs={12} lg={10}>
            <Box className="video-player-container experiencias-video-resumen">
              <Typography className="video-title">Resumen de las experiencias vivenciales 2025</Typography>
              <video controls className="video-player" preload="metadata">
                <source src={videoExperienciasVivenciales2025} type="video/mp4" />
                Tu navegador no soporta el elemento de video.
              </video>
            </Box>
          </Grid>
        </Grid>

        {/* Listado de experiencias con PDFs */}
        <Grid container spacing={2} className='experiencias-list-container' justifyContent='center'>
          {experienciasVivenciales2025.map((exp) => (
            <Grid item xs={12} md={6} lg={4} key={exp.num}>
              <Box className="experiencia-card">
                <Typography className="experiencia-num">Experiencia {exp.num}</Typography>
                <Typography className="experiencia-fecha">{exp.fecha}</Typography>
                <Typography className="experiencia-nombre">{exp.nombre}</Typography>
                <Typography className="experiencia-objetivo">{exp.objetivo}</Typography>
                <Button
                  variant="contained"
                  size="small"
                  className="action-button purple-button"
                  href={exp.pdf}
                  target="_blank"
                  rel="noopener noreferrer"
                  fullWidth
                  sx={{ mt: 1.5 }}
                >
                  Ver fotos (PDF)
                </Button>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Grid>

      {/* Image Modal */}
      <Dialog open={open} onClose={handleClose} maxWidth="lg" className="image-modal">
        <DialogContent style={{ padding: 0 }}>
          {selectedImage && (
            <img
              src={selectedImage}
              alt="Imagen ampliada"
              style={{
                width: '100%',
                height: 'auto',
                display: 'block',
              }}
            />
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default EstrategiasComunicacion2025;

